import { InputHTMLAttributes, forwardRef } from 'react';
import { cn } from '../../lib/utils/classnameVariants';

export interface ParagraphProps extends InputHTMLAttributes<HTMLDivElement> {
  heading?: string;
  text: string;
}

const Paragraph = forwardRef<HTMLDivElement, ParagraphProps>(({ className, heading, text, ...props }, ref) => (
  <div {...props} ref={ref} className={cn('flex flex-col gap-2', className)}>
    {heading && (
      <p className="line-clamp-6 text-ellipsis break-normal font-graphik text-md font-bold text-black-900">{heading}</p>
    )}
    <p className="text-ellipsis break-normal text-black-900">{text}</p>
  </div>
));
Paragraph.displayName = 'Paragraph';

export { Paragraph };
